/** Display helper for Floor Sheet Preheat Min/Max cells (empty → --). */
export function formatPreheatBoundDisplay(value: string | undefined | null): string {
  const trimmed = typeof value === 'string' ? value.trim() : ''
  return trimmed || '--'
}
